module.exports = __webpack_public_path__ + "assets/img/check.1073eac7.svg";